import React from 'react';

import { ListItemIcon, MenuItem } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { useCopyVersionStore } from 'store/copyVersion.store';

import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { LoaderSpinner } from 'components/common/LodaerSpinner/LoaderSpinner';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';
import ActionMenu from 'components/widgets/RenderLibraryTable/components/ActionMenu/ActionMenu';
import { ActionButtonMenu } from 'components/widgets/RenderLibraryTable/components/ActionMenu/components/ActionButtonMenu/ActionButtonMenu';

export const ActionMenuOk = ({
    versionHashCode,
    status,
    errorMessage,
    index,
    setShowModal,
    onDownLoad,
    isLoading,
    isFileDownload,
    isAllowedToCopyVersion,
    id,
    setShowRenameVersionModal,
}) => {
    const { update } = useCopyVersionStore();
    const history = useHistory();
    const integratedProgramDetailsLink = AppRoutes.buildPathWithQuery(
        [
            AppRoutes.DASHBOARD_PLANNING_PATH,
            executionConfig.programLibrary.link,
            executionConfig.integratedProgramDetails.link,
        ],
        { metaDataId: id },
    );

    return (
        <>
            <ActionMenu
                versionIdList={versionHashCode}
                status={status}
                errorMessage={errorMessage}
                id={`viewAnalytics_${index}`}
            />
            {isLoading ? (
                <LoaderSpinner />
            ) : (
                <ActionButtonMenu id={`threeDots_${index}`} tooltipContent={'More Actions'}>
                    <MenuItem onClick={() => history.push(integratedProgramDetailsLink)}>
                        <ListItemIcon>
                            <MuiIcon icon={'info'} type={'outlined'} />
                        </ListItemIcon>
                        Details
                    </MenuItem>
                    {isFileDownload && (
                        <MenuItem onClick={onDownLoad}>
                            <ListItemIcon>
                                <MuiIcon icon={'download'} />
                            </ListItemIcon>
                            Download File
                        </MenuItem>
                    )}

                    <MenuItem onClick={() => setShowRenameVersionModal(true)}>
                        <ListItemIcon>
                            <MuiIcon icon={'edit'} />
                        </ListItemIcon>
                        Rename Version
                    </MenuItem>

                    {isAllowedToCopyVersion && (
                        <MenuItem
                            onClick={() => {
                                update({ versionId: id, versionHashCode: versionHashCode, showModal: true });
                            }}
                        >
                            <ListItemIcon>
                                <MuiIcon icon={'content_copy'} />
                            </ListItemIcon>
                            Copy Version
                        </MenuItem>
                    )}

                    <MenuItem onClick={() => setShowModal(true)}>
                        <ListItemIcon>
                            <MuiIcon icon={'delete'} type={'outlined'} />
                        </ListItemIcon>
                        Delete
                    </MenuItem>
                </ActionButtonMenu>
            )}
        </>
    );
};
